import React, { useEffect } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import { useDispatch, useSelector } from 'react-redux';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import './style.scss';
import MyButtonWhite from '../../components/UI/button/MyButtonWhite';
import CreativeQuizContent from './CreativeQuizContent';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClickNot, setIconButtonNot, setIsShowButtonNot, setTextButtonNot } from '../../store/buttonNotSlice';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';
import MyButton from '../../components/UI/button/MyButton';

export default function CreativeQuiz() {

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const buttonNotClicked = useSelector((state) => state.buttonNot.buttonClicked);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            queryParams.set('static-ads', 1);
            trackP1Event('onboarding_static_ads', {
                user_response: 'I’m in!'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    useEffect(() => {
        if (buttonNotClicked) {
            dispatch(setButtonClickNot(false));
            trackP1Event('onboarding_static_ads', {
                user_response: 'Not sure'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonNotClicked, dispatch]);

    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('I’m in!'));
        dispatch(setIconButton('Tick'));

        dispatch(setIsShowButtonNot(true));
        dispatch(setTextButtonNot('Not sure'));
        dispatch(setIconButtonNot('not'));
    }, []);

    const handleClick = () => {
        queryParams.set('static-ads', 1);
        trackP1Event('onboarding_static_ads', {
            user_response: 'I’m in!'
        })
        history.push({
            pathname: nextPage,
            search: `?${queryParams.toString()}`
        });
    }

    const handleClickNot = () => {
        trackP1Event('onboarding_static_ads', {
            user_response: 'Not sure'
        })
        history.push({
            pathname: nextPage,
            search: `?${queryParams.toString()}`
        });
    }

    return (
        <div className="page creative-quiz">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '12rem' }}
                        title={'Would you like to have quick static ads made with AI?'}
                    />
                    <p className="text" style={{ marginBottom: '24rem' }}>
                        AI handles writing and generating visuals
                    </p>
                    <div className="creative-quiz-wrapper">
                        <CreativeQuizContent />
                    </div>

                </div>
            </PageContent>
            <div className="block-button">

                <MyButtonWhite
                    style={{ marginBottom: '8rem' }}
                    buttonText={'Not sure'}
                    buttonTime={'150'}
                    buttonIcon={'not'}
                    onClick={() => handleClickNot()}
                />

                <MyButton
                    buttonStatus={''}
                    buttonTime={'150'}
                    buttonText={'I’m in!'}
                    buttonIcon={'Tick'}
                    onClick={() => handleClick()}
                // className={`${buttonError ? 'error' : ''
                //     }`}
                >

                </MyButton>


            </div>

        </div>
    );
}
